import { render } from "./DnsRecordsTable.vue?vue&type=template&id=4bc2e710&scoped=true"
import script from "./DnsRecordsTable.vue?vue&type=script&lang=js"
export * from "./DnsRecordsTable.vue?vue&type=script&lang=js"

import "./DnsRecordsTable.vue?vue&type=style&index=0&id=4bc2e710&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc2e710"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QIcon,QTr,QTd,QTooltip});
